import {Component, jsx} from 'panel';
import {VNode} from 'snabbdom/vnode';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {SidebarEl} from 'common/components/sidebar';
import {layoutManager} from 'common/report/util/layout-manager';

import {QueryReportHeaderAttrs} from '../query-report-header/types';
import {QueryBuilderAttrs} from '../query-builder/types';
import css from './index.styl?inline';

export const PAGE_CONTENT_WIDTH = 1366;

type FullWidthReportJsxProps = {
  on?: EmptyObj;
  attrs?: EmptyObj;
  props?: {
    queryBuilderConfig: Partial<QueryReportHeaderAttrs>;
  };
};

/**
 * Layout component for a full width report
 * Provides a sidebar and report content sections both independetly scrollable
 *
 * @TODO [pablo] make this component query builder aware by rendering report specific
 * components (report header or qb) by itself taking a config object
 */
export class FullWidthReport extends Component<UnknownObj> {
  private _queryBuilderConfig: QueryBuilderAttrs;

  static get attrsSchema() {
    return {
      ...super.attrsSchema,
    };
  }

  get config() {
    return {
      css,
      useShadowDom: true,
      template: () => this.renderTemplate(),
    };
  }

  get queryBuilderConfig() {
    return this._queryBuilderConfig;
  }

  set queryBuilderConfig(_config) {
    this._queryBuilderConfig = _config;
    this.update();
  }

  renderTemplate() {
    return (
      <div sel='.fullwidth-report'>
        <SidebarEl
          attrs={{'storage-key': `query-builder`, 'show-collapse-button': true}}
          on={{sidebarResize: (ev) => this.handleSidebarResize(ev.detail.width)}}
        >
          <slot attrs={{name: `query`}} />
        </SidebarEl>
        <div sel='.right-panel'>
          <div sel='.banner-container' hook={{insert: this.onBannerContainerInserted}} />
          {/* <div sel='.mp-query-report-header'><QueryReportHeaderEl attrs={this.queryBuilderConfig} /></div> */}
          <slot attrs={{name: `report-header`}} />
          <div sel='.report-container'>
            <slot attrs={{name: `report`}} />
          </div>
        </div>
      </div>
    );
  }

  onBannerContainerInserted(vnode: VNode) {
    layoutManager.setConfig({
      bannerContainer: vnode.elm as HTMLElement,
    });
  }

  handleSidebarResize(width: number) {
    this.style.setProperty(`--sidebar-width`, `${width}px`);
  }

  constructor() {
    super();
    const {fullWidth, whiteBackground} = layoutManager.getConfig();
    if (!fullWidth) {
      layoutManager.setConfig({
        fullWidth: true,
        whiteBackground: true,
      });
      this.onDisconnected(() =>
        layoutManager.setConfig({
          fullWidth,
          whiteBackground,
        }),
      );
    }
  }
}

export const FullWidthReportEl = defineAndMakeJsxFactory<FullWidthReportJsxProps>(
  `mp-fullwidth-report`,
  FullWidthReport,
);
